export const DistinctGameStyles = `
    .UFOV-brain-games__orbit,
    .UFOV-brain-games__tone-game,
    .UFOV-brain-games__blink-game,
    .UFOV-brain-games__rule-matrix-game,
    .UFOV-brain-games__tower-game,
    .UFOV-brain-games__source-game,
    .UFOV-brain-games__route-game,
    .UFOV-brain-games__line-game {
        justify-self: center;
        width: min(360px, 100%);
    }

    .UFOV-brain-games__orbit {
        aspect-ratio: 1;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 24px;
        box-shadow: 0 18px 38px rgba(31, 41, 55, 0.09);
        overflow: hidden;
        position: relative;
    }

    .UFOV-brain-games__orbit button {
        background: #4f77ee;
        border: 0;
        border-radius: 999px;
        box-shadow: 0 8px 16px rgba(79, 119, 238, 0.22);
        height: 34px;
        margin: -17px 0 0 -17px;
        padding: 0;
        position: absolute;
        transition: left 520ms ease-in-out, top 520ms ease-in-out, box-shadow 140ms ease, transform 140ms ease;
        width: 34px;
    }

    .UFOV-brain-games__orbit button.is-target {
        box-shadow: 0 0 0 7px #ffd84d, 0 10px 20px rgba(31, 41, 55, 0.16);
    }

    .UFOV-brain-games__orbit button.is-correct {
        background: #20a46b;
        box-shadow: 0 0 0 6px rgba(32, 164, 107, 0.2);
    }

    .UFOV-brain-games__orbit button.is-wrong {
        background: #e95569;
        box-shadow: 0 0 0 6px rgba(233, 85, 105, 0.18);
    }

    .UFOV-brain-games__tone-play {
        align-items: center;
        background: #111827;
        border: 0;
        border-radius: 999px;
        box-shadow: 0 14px 28px rgba(17, 24, 39, 0.16);
        color: #ffffff;
        display: inline-flex;
        height: 58px;
        justify-content: center;
        width: 82px;
    }

    .UFOV-brain-games__tone-play svg {
        height: 26px;
        width: 26px;
    }

    .UFOV-brain-games__line-options {
        display: grid;
        gap: 12px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: min(330px, 100%);
    }

    .UFOV-brain-games__tone-options button,
    .UFOV-brain-games__blink-options button,
    .UFOV-brain-games__matrix-options button,
    .UFOV-brain-games__source-grid button,
    .UFOV-brain-games__route-grid button,
    .UFOV-brain-games__line-options button {
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        box-shadow: 0 12px 24px rgba(31, 41, 55, 0.08);
        color: #111827;
        font: inherit;
        font-weight: 600;
    }

    .UFOV-brain-games__tone-game {
        display: grid;
        gap: 28px;
        justify-items: center;
    }

    .UFOV-brain-games__tone-play:disabled {
        opacity: 0.72;
    }

    .UFOV-brain-games__tone-options {
        display: grid;
        gap: 12px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: min(330px, 100%);
    }

    .UFOV-brain-games__tone-options button {
        border-radius: 20px;
        min-height: 120px;
    }

    .UFOV-brain-games__tone-options button.is-correct {
        background: #e5f8ef;
        box-shadow: 0 0 0 5px rgba(32, 164, 107, 0.16);
    }

    .UFOV-brain-games__tone-options button.is-picked:not(.is-correct) {
        background: #ffe7ec;
        box-shadow: 0 0 0 5px rgba(233, 85, 105, 0.14);
    }

    .UFOV-brain-games__tone-pattern {
        align-items: flex-end;
        display: flex;
        gap: 9px;
        height: 56px;
        justify-content: center;
    }

    .UFOV-brain-games__tone-pattern i {
        background: #4f77ee;
        border-radius: 999px;
        display: block;
        width: 13px;
    }

    .UFOV-brain-games__blink-game {
        align-items: center;
        display: grid;
        gap: 22px;
        justify-items: center;
    }

    .UFOV-brain-games__blink-stream {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 24px;
        box-shadow: 0 18px 38px rgba(31, 41, 55, 0.1);
        color: #111827;
        display: flex;
        font: inherit;
        font-size: 82px;
        font-weight: 600;
        height: 190px;
        justify-content: center;
        padding: 0;
        width: 190px;
    }

    .UFOV-brain-games__blink-stream svg {
        height: 36px;
        width: 36px;
    }

    .UFOV-brain-games__blink-slots {
        display: grid;
        gap: 12px;
        grid-template-columns: repeat(2, 84px);
    }

    .UFOV-brain-games__blink-slots span {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 18px;
        box-shadow: 0 12px 24px rgba(31, 41, 55, 0.08);
        color: #111827;
        display: flex;
        font-size: 38px;
        font-weight: 600;
        height: 84px;
        justify-content: center;
    }

    .UFOV-brain-games__blink-slots.is-correct span {
        background: #e5f8ef;
        color: #176f4a;
    }

    .UFOV-brain-games__blink-slots.is-wrong span {
        background: #ffe7ec;
        color: #9b304a;
    }

    .UFOV-brain-games__blink-options {
        display: grid;
        gap: 9px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        width: min(300px, 100%);
    }

    .UFOV-brain-games__blink-options button {
        border-radius: 14px;
        font-size: 22px;
        min-height: 58px;
    }

    .UFOV-brain-games__rule-matrix-game {
        display: grid;
        gap: 18px;
        justify-items: center;
    }

    .UFOV-brain-games__rule-matrix {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        width: min(318px, 100%);
    }

    .UFOV-brain-games__rule-matrix > div {
        align-items: center;
        aspect-ratio: 1;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 16px;
        box-shadow: 0 9px 18px rgba(31, 41, 55, 0.06);
        display: flex;
        justify-content: center;
    }

    .UFOV-brain-games__rule-matrix > div.is-missing {
        border-style: dashed;
        box-shadow: none;
    }

    .UFOV-brain-games__matrix-missing {
        color: #9aa2b1;
        font-size: 31px;
        font-weight: 600;
    }

    .UFOV-brain-games__matrix-token {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        justify-content: center;
        max-width: 58px;
    }

    .UFOV-brain-games__matrix-number {
        color: #22314a;
        font-size: clamp(25px, 8vw, 34px);
        font-weight: 600;
        line-height: 1;
    }

    .UFOV-brain-games__matrix-position-grid {
        display: grid;
        gap: 4px;
        grid-template-columns: repeat(var(--matrix-position-size), 1fr);
        height: 58px;
        width: 58px;
    }

    .UFOV-brain-games__matrix-position-grid i {
        background: transparent;
        border-radius: 50%;
        display: block;
        min-height: 0;
        min-width: 0;
    }

    .UFOV-brain-games__matrix-position-grid i.is-active {
        background: #315fcb;
        box-shadow: 0 3px 7px rgba(49, 95, 203, 0.18);
    }

    .UFOV-brain-games__matrix-token i {
        border: 3px solid #34445e;
        display: block;
        height: 17px;
        width: 17px;
    }

    .UFOV-brain-games__matrix-token.is-size-0 i { height: 10px; width: 10px; }
    .UFOV-brain-games__matrix-token.is-size-1 i { height: 14px; width: 14px; }
    .UFOV-brain-games__matrix-token.is-size-2 i { height: 18px; width: 18px; }
    .UFOV-brain-games__matrix-token.is-size-3 i { height: 23px; width: 23px; }
    .UFOV-brain-games__matrix-token.is-size-4 i { height: 29px; width: 29px; }

    .UFOV-brain-games__matrix-token i.is-filled {
        background: #4f77ee;
        border-color: #4f77ee;
    }

    .UFOV-brain-games__matrix-token i.is-circle {
        border-radius: 999px;
    }

    .UFOV-brain-games__matrix-token i.is-square {
        border-radius: 4px;
    }

    .UFOV-brain-games__matrix-token i.is-triangle {
        clip-path: polygon(50% 2%, 98% 96%, 2% 96%);
    }

    .UFOV-brain-games__matrix-options {
        display: grid;
        gap: 9px;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        width: min(318px, 100%);
    }

    .UFOV-brain-games__matrix-options button {
        align-items: center;
        aspect-ratio: 1;
        border-radius: 14px;
        display: flex;
        justify-content: center;
        padding: 4px;
    }

    .UFOV-brain-games__matrix-options button:disabled {
        opacity: 1;
    }

    .UFOV-brain-games__matrix-options button.is-correct {
        background: #e5f8ef;
        box-shadow: 0 0 0 5px rgba(32, 164, 107, 0.16);
    }

    .UFOV-brain-games__matrix-options button.is-picked:not(.is-correct) {
        background: #ffe7ec;
    }

    .UFOV-brain-games__tower-game {
        display: grid;
        gap: 10px;
        justify-items: center;
        position: relative;
        transform: translateY(-36px);
    }

    .UFOV-brain-games__tower-copy-card {
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 14px;
        box-shadow: 0 12px 26px rgba(31, 41, 55, 0.08);
        display: grid;
        gap: 0;
        padding: 8px 10px 6px;
        width: min(206px, 58vw);
    }

    .UFOV-brain-games__tower-copy-label {
        color: #64748b;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.1;
        text-align: center;
    }

    .UFOV-brain-games__tower-board {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        width: min(330px, 100%);
    }

    .UFOV-brain-games__tower-board button {
        background: transparent;
        border: 0;
        height: 150px;
        padding: 0 4px;
        position: relative;
    }

    .UFOV-brain-games__tower-board.is-goal {
        opacity: 1;
        width: 100%;
    }

    .UFOV-brain-games__tower-board.is-goal button {
        height: 60px;
        padding: 0 2px;
    }

    .UFOV-brain-games__tower-board.is-goal button::after {
        bottom: 1px;
        height: 5px;
    }

    .UFOV-brain-games__tower-board.is-goal .UFOV-brain-games__tower-pole {
        bottom: 5px;
        top: 7px;
        width: 4px;
    }

    .UFOV-brain-games__tower-board.is-goal .UFOV-brain-games__tower-balls {
        bottom: 6px;
        gap: 1px;
        left: 4px;
        right: 4px;
    }

    .UFOV-brain-games__tower-board.is-goal .UFOV-brain-games__tower-balls i {
        border-width: 2px;
        box-shadow: 0 3px 6px rgba(31, 41, 55, 0.13);
        height: 18px;
        width: 36px;
    }

    .UFOV-brain-games__tower-board button::after {
        background: #cbd2dd;
        border-radius: 999px;
        bottom: 3px;
        content: '';
        height: 8px;
        left: 0;
        position: absolute;
        right: 0;
    }

    .UFOV-brain-games__tower-board button.is-selected {
        background: #eef3ff;
        border-radius: 16px;
        box-shadow: inset 0 0 0 2px #4f77ee;
    }

    .UFOV-brain-games__tower-game.is-solved .UFOV-brain-games__tower-board.is-interactive {
        animation: UFOV-tower-solved 1.2s cubic-bezier(0.22, 0.8, 0.32, 1) both;
    }

    .UFOV-brain-games__tower-game.is-solved .UFOV-brain-games__tower-board.is-interactive .UFOV-brain-games__tower-balls i {
        animation: UFOV-tower-ball-complete 0.62s cubic-bezier(0.2, 0.85, 0.3, 1.25) both;
        box-shadow: 0 0 0 4px rgba(32, 164, 107, 0.18), 0 5px 10px rgba(31, 41, 55, 0.16);
    }

    .UFOV-brain-games__tower-game.is-solved .UFOV-brain-games__tower-board.is-interactive button:nth-child(2) .UFOV-brain-games__tower-balls i {
        animation-delay: 80ms;
    }

    .UFOV-brain-games__tower-game.is-solved .UFOV-brain-games__tower-board.is-interactive button:nth-child(3) .UFOV-brain-games__tower-balls i {
        animation-delay: 160ms;
    }

    .UFOV-brain-games__tower-game.is-solved .UFOV-brain-games__tower-board.is-interactive button::after,
    .UFOV-brain-games__tower-game.is-solved .UFOV-brain-games__tower-board.is-interactive .UFOV-brain-games__tower-pole {
        animation: UFOV-tower-support-complete 1.2s ease both;
    }

    .UFOV-brain-games__tower-complete {
        align-items: center;
        animation: UFOV-tower-check-complete 1.2s cubic-bezier(0.22, 0.8, 0.32, 1) both;
        background: #20a46b;
        border: 7px solid #ffffff;
        border-radius: 999px;
        bottom: 52px;
        box-shadow: 0 14px 30px rgba(32, 164, 107, 0.28);
        color: #ffffff;
        display: flex;
        height: 70px;
        justify-content: center;
        left: 50%;
        pointer-events: none;
        position: absolute;
        transform: translateX(-50%);
        width: 70px;
        z-index: 4;
    }

    .UFOV-brain-games__tower-complete svg {
        height: 34px;
        width: 34px;
    }

    @keyframes UFOV-tower-solved {
        0%, 100% { transform: scale(1); }
        16% { transform: scale(0.97); }
        48% { transform: scale(1.055); }
        72% { transform: scale(1.015); }
    }

    @keyframes UFOV-tower-ball-complete {
        0%, 100% { transform: translateY(0) scale(1); }
        46% { transform: translateY(-12px) scale(1.06); }
    }

    @keyframes UFOV-tower-support-complete {
        0%, 100% { background: #cbd2dd; }
        22%, 78% { background: #5ccf9c; }
    }

    @keyframes UFOV-tower-check-complete {
        0% {
            opacity: 0;
            transform: translateX(-50%) scale(0.35) rotate(-18deg);
        }
        24% {
            opacity: 1;
            transform: translateX(-50%) scale(1.12) rotate(3deg);
        }
        40%, 76% {
            opacity: 1;
            transform: translateX(-50%) scale(1) rotate(0);
        }
        100% {
            opacity: 0;
            transform: translateX(-50%) translateY(-12px) scale(0.86);
        }
    }

    .UFOV-brain-games__tower-pole {
        background: #cbd2dd;
        border-radius: 999px;
        bottom: 8px;
        left: calc(50% - 3px);
        position: absolute;
        top: 12px;
        width: 6px;
    }

    .UFOV-brain-games__tower-balls {
        align-items: center;
        bottom: 10px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        left: 10px;
        position: absolute;
        right: 10px;
    }

    .UFOV-brain-games__tower-balls i {
        border: 3px solid #ffffff;
        border-radius: 999px;
        box-shadow: 0 5px 10px rgba(31, 41, 55, 0.16);
        display: block;
        height: 30px;
        width: 56px;
    }

    .UFOV-brain-games__tower-balls i.is-blue { background: #3478ea; }
    .UFOV-brain-games__tower-balls i.is-pink { background: #e95f98; }
    .UFOV-brain-games__tower-balls i.is-yellow { background: #ffd12e; }
    .UFOV-brain-games__tower-balls i.is-green { background: #26a56f; }

    .UFOV-brain-games__tower-divider {
        background: #dce1e8;
        height: 1px;
        width: min(280px, 80%);
    }

    .UFOV-brain-games__source-game {
        display: grid;
        gap: 18px;
        justify-items: center;
    }

    .UFOV-brain-games__transient-slot {
        align-items: center;
        display: grid;
        justify-items: center;
        min-height: var(--UFOV-transient-slot-height, 76px);
        width: 100%;
    }

    .UFOV-brain-games__transient-slot.is-source-cue {
        --UFOV-transient-slot-height: 76px;
    }

    .UFOV-brain-games__transient-slot.is-route-cue {
        --UFOV-transient-slot-height: 106px;
    }

    .UFOV-brain-games__source-cue {
        align-items: center;
        background: #ffffff;
        border: 1px solid color-mix(in srgb, var(--source-tone) 22%, transparent);
        border-radius: 18px;
        box-shadow: 0 12px 24px rgba(31, 41, 55, 0.08);
        display: flex;
        height: 76px;
        justify-content: center;
        width: 76px;
    }

    .UFOV-brain-games__source-cue img,
    .UFOV-brain-games__source-grid img {
        height: 78%;
        object-fit: contain;
        width: 78%;
    }

    .UFOV-brain-games__source-grid {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        width: min(324px, 100%);
    }

    .UFOV-brain-games__source-grid.is-4 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: min(260px, 78vw);
    }

    .UFOV-brain-games__source-grid button {
        align-items: center;
        aspect-ratio: 1;
        border-radius: 18px;
        display: flex;
        justify-content: center;
        padding: 3px;
    }

    .UFOV-brain-games__source-grid button.is-correct,
    .UFOV-brain-games__source-grid button.is-answer {
        background: #e5f8ef;
        box-shadow: 0 0 0 5px rgba(32, 164, 107, 0.16);
    }

    .UFOV-brain-games__source-grid button.is-wrong {
        background: #ffe7ec;
    }

    .UFOV-brain-games__route-game {
        align-items: center;
        display: grid;
        gap: 20px;
        justify-items: center;
    }

    .UFOV-brain-games__route-arrow {
        align-content: center;
        align-items: center;
        color: #213a63;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        min-height: var(--UFOV-transient-slot-height, 106px);
        justify-content: center;
        width: min(320px, 100%);
    }

    .UFOV-brain-games__route-step {
        align-items: center;
        animation: UFOV-route-step-in 0.28s ease both;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 10px;
        box-shadow: 0 7px 16px rgba(31, 41, 55, 0.09);
        display: flex;
        height: 48px;
        justify-content: center;
        width: 48px;
    }

    .UFOV-brain-games__route-step svg {
        height: 27px;
        width: 27px;
    }

    @keyframes UFOV-route-step-in {
        from { opacity: 0; transform: scale(0.82); }
        to { opacity: 1; transform: scale(1); }
    }

    .UFOV-brain-games__route-grid {
        display: grid;
        gap: 7px;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        width: min(326px, 100%);
    }

    .UFOV-brain-games__route-grid button {
        aspect-ratio: 1;
        border-radius: 12px;
        padding: 0;
    }

    .UFOV-brain-games__route-grid button.is-start {
        background: #4f77ee;
        box-shadow: 0 0 0 6px rgba(79, 119, 238, 0.17);
    }

    .UFOV-brain-games__route-grid button.is-correct,
    .UFOV-brain-games__route-grid button.is-answer {
        background: #20a46b;
        box-shadow: 0 0 0 5px rgba(32, 164, 107, 0.16);
    }

    .UFOV-brain-games__route-grid button.is-wrong {
        background: #e95569;
    }

    .UFOV-brain-games__line-game {
        display: grid;
        gap: 14px;
        justify-items: center;
    }

    .UFOV-brain-games__line-preview {
        display: grid;
        gap: 14px;
        justify-items: center;
    }

    .UFOV-brain-games__line-cue {
        color: #6b7280;
        font-size: 16px;
        font-weight: 600;
        line-height: 1.2;
        text-align: center;
    }

    .UFOV-brain-games__line-countdown {
        color: #27354b;
        font-size: 20px;
        font-variant-numeric: tabular-nums;
        line-height: 1;
    }

    .UFOV-brain-games__line-reference,
    .UFOV-brain-games__line-options button {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 16px;
        box-shadow: 0 18px 36px rgba(31, 41, 55, 0.09);
        display: flex;
        justify-content: center;
    }

    .UFOV-brain-games__line-reference {
        min-height: 166px;
        width: min(166px, 50vw);
    }

    .UFOV-brain-games__line-options {
        gap: 10px;
        width: min(276px, 84vw);
    }

    .UFOV-brain-games__line-options button {
        min-height: 128px;
    }

    .UFOV-brain-games__line-options button.is-correct {
        background: #e5f8ef;
        box-shadow: 0 0 0 5px rgba(32, 164, 107, 0.16);
    }

    .UFOV-brain-games__line-options button.is-picked:not(.is-correct) {
        background: #ffe7ec;
    }

    .UFOV-brain-games__line-stimulus {
        align-items: center;
        display: flex;
        height: 94px;
        justify-content: center;
        width: 94px;
    }

    .UFOV-brain-games__line-stimulus i {
        background: #27354b;
        border-radius: 999px;
        display: block;
        height: 78px;
        width: 7px;
    }

    .UFOV-brain-games__line-reference .UFOV-brain-games__line-stimulus {
        height: 116px;
        width: 116px;
    }

    .UFOV-brain-games__line-reference .UFOV-brain-games__line-stimulus i {
        height: 98px;
    }

    @keyframes UFOV-dual-impact {
        0%, 100% { transform: translateX(0); }
        30% { transform: translateX(-3px); }
        60% { transform: translateX(3px); }
    }

    @media (orientation: portrait) {
        .UFOV-brain-games__screen.is-dual-track-game {
            height: 100vw;
            left: 50%;
            max-width: none;
            min-height: 0;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%) rotate(90deg);
            transform-origin: center;
            width: var(--UFOV-resolved-app-height);
        }
    }

        .UFOV-brain-games__screen.is-dual-track-game {
            gap: 7px;
            max-width: none;
            overflow: hidden;
            padding:
                max(7px, env(safe-area-inset-top, 0px))
                max(12px, env(safe-area-inset-right, 0px))
                max(8px, env(safe-area-inset-bottom, 0px))
                max(12px, env(safe-area-inset-left, 0px));
        }

        .UFOV-brain-games__screen.is-dual-track-game .UFOV-brain-games__play-body {
            align-content: stretch;
        }

        .UFOV-brain-games__dual-game {
            display: grid;
            gap: 8px;
            grid-template-rows: minmax(0, 1fr) auto 66px;
            height: 100%;
            justify-self: center;
            min-height: 0;
            width: min(860px, 100%);
        }

        .UFOV-brain-games__dual-stage {
            min-height: 0;
            overflow: hidden;
            position: relative;
        }

        .UFOV-brain-games__dual-stage canvas {
            display: block;
            height: 100%;
            touch-action: none;
            width: 100%;
        }

        .UFOV-brain-games__dual-game.is-collision .UFOV-brain-games__dual-stage {
            animation: UFOV-dual-impact 140ms ease-out;
        }

        .UFOV-brain-games__dual-controls {
            display: grid;
            gap: 12px;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            min-height: 0;
        }

        .UFOV-brain-games__dual-control {
            align-items: center;
            background: #ffffff;
            border: 1px solid #d9dee7;
            border-radius: 18px;
            box-shadow: 0 9px 20px rgba(31, 41, 55, 0.08);
            cursor: ew-resize;
            display: flex;
            min-width: 0;
            position: relative;
            touch-action: none;
            transition: border-color 160ms ease, box-shadow 160ms ease;
        }

        .UFOV-brain-games__dual-control-rail {
            background: #e2e6ed;
            border-radius: 999px;
            height: 7px;
            left: 14px;
            position: absolute;
            right: 14px;
        }

        .UFOV-brain-games__dual-control-travel {
            bottom: 0;
            left: 28px;
            position: absolute;
            right: 28px;
            top: 0;
        }

        .UFOV-brain-games__dual-control-endpoint {
            height: 1px;
            position: absolute;
            top: 50%;
            width: 1px;
        }

        .UFOV-brain-games__dual-control-endpoint.is-start {
            left: 0;
        }

        .UFOV-brain-games__dual-control-endpoint.is-end {
            right: 0;
        }

        .UFOV-brain-games__dual-control-thumb {
            align-items: center;
            background: #3c78e8;
            border: 4px solid #ffffff;
            border-radius: 50%;
            box-shadow: 0 6px 14px rgba(60, 120, 232, 0.24);
            display: flex;
            height: 42px;
            justify-content: center;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%) scale(1);
            transition: background-color 150ms ease, box-shadow 150ms ease, transform 140ms ease;
            width: 42px;
        }

        .UFOV-brain-games__dual-control.is-right .UFOV-brain-games__dual-control-thumb {
            background: #f08a3e;
            box-shadow: 0 6px 14px rgba(240, 138, 62, 0.24);
        }

        .UFOV-brain-games__dual-control-thumb i {
            background: rgba(255, 255, 255, 0.92);
            border-radius: 50%;
            display: block;
            height: 10px;
            width: 10px;
        }

        .UFOV-brain-games__dual-control:active .UFOV-brain-games__dual-control-thumb {
            transform: translate(-50%, -50%) scale(0.9);
        }

        .UFOV-brain-games__dual-control.is-outside {
            border-color: #d83b55;
            box-shadow: 0 0 0 4px rgba(216, 59, 85, 0.12);
        }

        .UFOV-brain-games__dual-control.is-outside .UFOV-brain-games__dual-control-thumb {
            background: #d83b55;
            box-shadow: 0 6px 14px rgba(216, 59, 85, 0.24);
        }

        .UFOV-brain-games__screen.is-dual-track-game .UFOV-brain-games__tutorial {
            gap: 10px;
            max-width: 520px;
            padding: 18px 24px;
        }

        .UFOV-brain-games__screen.is-dual-track-game .UFOV-brain-games__tutorial-icon {
            height: 42px;
            width: 42px;
        }

        .UFOV-brain-games__screen.is-dual-track-game .UFOV-brain-games__tutorial strong {
            font-size: 21px;
        }

        .UFOV-brain-games__screen.is-dual-track-game .UFOV-brain-games__tutorial ol {
            gap: 4px;
        }

        .UFOV-brain-games__screen.is-dual-track-game .UFOV-brain-games__tutorial button {
            min-height: 48px;
        }

    @media (max-height: 700px) {
        .UFOV-brain-games__orbit { width: min(310px, 90vw); }
        .UFOV-brain-games__blink-stream { height: 160px; width: 160px; }
        .UFOV-brain-games__rule-matrix { width: min(286px, 100%); }
        .UFOV-brain-games__matrix-options { width: min(286px, 100%); }
        .UFOV-brain-games__tower-board button { height: 126px; }
        .UFOV-brain-games__tower-board.is-goal button { height: 56px; }
        .UFOV-brain-games__line-reference { min-height: 150px; }
        .UFOV-brain-games__line-options button { min-height: 116px; }
    }
`;
